export enum DeriveDirection {
  PositiveIsBuy = 'PositiveIsBuy',
  PositiveIsSell = 'PositiveIsSell'
}
